import { queueMicroTask as r } from "./ghl-ui.es1726.js";
var u = function(e) {
  r(function() {
    requestAnimationFrame(e);
  });
};
export {
  u as queueResizeObserver
};
